var map = {
	"./DK/card-buy-page.json": 650,
	"./DR/card-buy-page.json": 651,
	"./OST2/card-buy-page.json": 652,
	"./PstViewer/card-buy-page.json": 653,
	"./SPB/card-buy-page.json": 654,
	"./Sync2/card-buy-page.json": 655,
	"./Sync2Cloud/card-buy-page.json": 656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;